import { FormControl, FormHelperText, InputLabel } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { DatePicker } from "@mui/x-date-pickers";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { TextField } from "formik-mui";
import moment from "moment";
import { useEffect, useState } from "react";

import { DateFieldProps } from "./Field";

const DateField = ({
	name,
	id,
	onChange,
	value,
	momentFormat,
	label,
	fullWidth = true,
	required,
	className,
	helpText,
	minDate,
	maxDate,
	disablePast = true,
	disableFuture = false,
	field,
	form,
	meta,
	disableInput,
	shouldDisableDate,
	shouldDisableTime,
	variant = "date",
	...others
}: DateFieldProps) => {
	const theme = useTheme();
	const [selectedDate, setSelectedDate] = useState<Date | undefined | null>(null);

	const fieldMeta = form.getFieldMeta(field.name);

	useEffect(() => {
		if (value && variant === "date") {
			setSelectedDate(moment(value, momentFormat).startOf("day").toDate());
		} else if (value && variant === "datetime") {
			const datetime = moment(value, momentFormat).toDate();
			//console.log("datetime", datetime);
			setSelectedDate(datetime);
		} else {
			setSelectedDate(null);
		}
	}, [value, momentFormat, variant]);

	const handleOnChange = (
		value: Date | null | undefined,
		KeyboardInputValue?: string | undefined
	) => {
		// if (value instanceof Date && !isNaN(value.getTime())) {
		setSelectedDate(value);
		if (variant === "date") {
			onChange && onChange(moment(value, momentFormat).startOf("day"));
		} else {
			onChange && onChange(moment(value, momentFormat));
		}
		// } else {
		// 	if (variant === "date") {
		// 		const dateValue = moment(KeyboardInputValue, momentFormat).startOf("day");

		// 		setSelectedDate(dateValue.toDate());
		// 		onChange && onChange(dateValue);
		// 	} else {
		// 		const dateTimeValue = moment(KeyboardInputValue, momentFormat);
		// 		setSelectedDate(dateTimeValue.toDate());
		// 		onChange && onChange(dateTimeValue);
		// 	}
		// }
	};
	const realId = id || name;

	const onKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
		if (disableInput) {
			event.preventDefault();
		}
	};

	const renderPicker = () => {
		if (variant === "date") {
			return (
				<DatePicker
					onChange={handleOnChange}
					value={selectedDate}
					renderInput={(params) => (
						<TextField
							{...params}
							field={field}
							form={form}
							meta={fieldMeta}
							onKeyDown={onKeyDown}
							FormHelperTextProps={{
								error: Boolean(
									fieldMeta.touched &&
										fieldMeta.error &&
										fieldMeta.error.length > 0
								),
								children: helpText,
							}}
							InputLabelProps={{
								error: Boolean(
									fieldMeta.touched &&
										fieldMeta.error &&
										fieldMeta.error.length > 0
								),
								children: helpText,
							}}
							// eslint-disable-next-line @typescript-eslint/ban-ts-comment
							// @ts-ignore
							error={Boolean(
								fieldMeta.touched && fieldMeta.error && fieldMeta.error.length > 0
							)}
							autoComplete="off"
						/>
					)}
					inputFormat="dd-MMM-yyyy"
					disablePast={disablePast}
					disableFuture={disableFuture}
					minDate={minDate}
					maxDate={maxDate}
					mask=""
					shouldDisableDate={shouldDisableDate}
					desktopModeMediaQuery="@media (min-width: 320px)"
				/>
			);
		} else {
			return (
				<DateTimePicker
					onChange={handleOnChange}
					value={selectedDate}
					renderInput={(params) => (
						<TextField
							{...params}
							field={field}
							form={form}
							meta={fieldMeta}
							onKeyDown={onKeyDown}
							FormHelperTextProps={{
								error: Boolean(
									fieldMeta.touched &&
										fieldMeta.error &&
										fieldMeta.error.length > 0
								),
								children: helpText,
							}}
							InputLabelProps={{
								error: Boolean(
									fieldMeta.touched &&
										fieldMeta.error &&
										fieldMeta.error.length > 0
								),
								children: helpText,
							}}
							// eslint-disable-next-line @typescript-eslint/ban-ts-comment
							// @ts-ignore
							error={Boolean(
								fieldMeta.touched && fieldMeta.error && fieldMeta.error.length > 0
							)}
							autoComplete="off"
							// InputProps={{
							// 	error: !meta?.error,
							// }}
						/>
					)}
					inputFormat="dd-MMM-yyyy hh:mm aaa"
					disablePast={disablePast}
					disableFuture={disableFuture}
					minDate={minDate}
					maxDate={maxDate}
					mask=""
					shouldDisableDate={shouldDisableDate}
					shouldDisableTime={shouldDisableTime}
					ampm={false}
					views={["year", "day", "hours"]}
					desktopModeMediaQuery="@media (min-width: 320px)"
				/>
			);
		}
	};

	return (
		<FormControl
			fullWidth={fullWidth}
			variant="standard"
			hiddenLabel
			className={className}
			required={required}
			// error={fieldMeta?.error !== undefined}s
		>
			{label && (
				<InputLabel
					style={{ position: "unset", transform: "none" }}
					disableAnimation
					htmlFor={realId}
					className="mb-1 text-sm font-semibold"
				>
					{label}
				</InputLabel>
			)}
			{renderPicker()}
			{/* {fieldMeta.touched && fieldMeta.error && (
				<FormHelperText id={`${realId}-error-text`} error>
					{fieldMeta.error}
				</FormHelperText>
			)} */}
		</FormControl>
	);
};

export default DateField;
